var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("Buyer Payments")]),_c('CCard',[_c('AccountPayments',{attrs:{"is-loading":_vm.isLoading,"payments":_vm.buyerAccountPayments,"account-type":"buyer"},on:{"reload-payments":_vm.getBuyerAccountPayments}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }